import { rewardsCertificateUrl } from "./endpoints.js";
const rewardsCertificateCacheKey = ({
  accountId,
  certificateRequestType,
  accountIdType,
  certificateNumber
}) => [
  rewardsCertificateUrl,
  { accountId, certificateRequestType, accountIdType, certificateNumber }
];
export {
  rewardsCertificateCacheKey
};
//# sourceMappingURL=cacheKeys.js.map
